import { render, staticRenderFns } from "./calendar-day.vue?vue&type=template&id=72d63bd5&"
import script from "./calendar-day.vue?vue&type=script&lang=js&"
export * from "./calendar-day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports